import React from 'react';
import { Benefits } from '../components/home/Benefits';
import { Coach } from '../components/home/Coach';
import { Community } from '../components/home/Community';
import { Faq } from '../components/home/Faq';
import { FinalCta } from '../components/home/FinalCta';
import { FirstClass } from '../components/home/FirstClass';
import { Hero } from '../components/home/Hero';
import { JonJonesVideo } from '../components/home/JonJonesVideo';
import { ParentFeedback } from '../components/home/ParentFeedback';
import { Programs } from '../components/home/Programs';
import { TrustStrip } from '../components/home/TrustStrip';
import { Visit } from '../components/home/Visit';
import { Footer } from '../components/layout/Footer';
import { Header } from '../components/layout/Header';
import { SchoolLife } from '../components/home/SchoolLife';
export function Home() {
  return <div className="min-h-screen w-full bg-paper text-ink" data-id="element-611" data-mp="3owlvkaclk0va">
      <Header data-id="element-612" data-mp="3ov2fajqxxpti" />
      <main id="main" data-id="element-613" data-mp="3oyyjr58y77gs">
        <Hero data-id="element-614" data-mp="30wjaok4gik28" />
        <TrustStrip data-id="element-615" data-mp="30x1hubsnqiox" />
        <JonJonesVideo data-id="element-616" data-mp="30vgo2oe633s4" />
        <Programs data-id="element-617" data-mp="30up285adgkf1" />
        <Benefits data-id="element-618" data-mp="2vxow5udivhnx" />
        <Coach data-id="element-619" data-mp="2vx6rc9csnv4e" />
        <ParentFeedback data-id="element-620" data-mp="2vyq7lzyga666" />
        <Community data-id="element-621" data-mp="2vy820cpwefll" />
        <SchoolLife data-id="element-622" data-mp="2vvlz4qdyco9p" />
        <FirstClass data-id="element-623" data-mp="2qybwua5gsi4g" />
        <Visit data-id="element-624" data-mp="2qxu3pme3mk0r" />
        <Faq data-id="element-625" data-mp="2qxale4kjdtm7" />
        <FinalCta data-id="element-626" data-mp="2qx0wylf53uim" />
      </main>
      <Footer data-id="element-627" data-mp="2mx0hqyk7vfai" />
    </div>;
}